import * as angular from 'angular';
import * as _ from 'lodash';
import { IStudent } from '../../../../ng2/shared/typings/interfaces/student.interface';
import { StudentSupportModalCtrl } from './student-support-modal.controller';

export class StudentSupportModal {
  static $inject: string[] = ['$mdDialog', 'School', 'Student', 'StudentSupport', 'Support', 'UtilitiesService'];

  constructor(
    private $mdDialog,
    private School,
    private Student: IStudent,
    private StudentSupport,
    private Support,
    private UtilitiesService,
  ) {}

  show(schoolId, studentIds, studentSupportId, exam?, v3View?): Promise<any> {
    const STUDENT_SUPPORT_TEMPLATE = {
      schoolId: null,
      startsOn: null,
      reviewOn: [],
      initialPrimaryOutcomeMetrics: [],
      student: {
        name: null,
        studentId: null,
      },
      status: 'ACTIVE',
      support: {
        supportId: null,
        name: null,
        category: null,
      },
    };

    const Modes = {
      EDIT_SINGLE: {
        UI: 'EDIT_SINGLE',
        template: require('./student-support-modal-edit.html'),
      },
      ASSIGN_SINGLE: {
        UI: 'ASSIGN_SINGLE',
        template: require('./student-support-modal-assign.html'),
      },
      ASSIGN_MANY: {
        UI: 'ASSIGN_MANY',
        template: require('./student-support-modal-assign.html'),
      },
    };

    let mode;
    // set UI-mode based on arguments
    if (_.isArray(arguments[1])) {
      mode = Modes.ASSIGN_MANY;
    } else if (studentSupportId) {
      mode = Modes.EDIT_SINGLE;
    } else {
      mode = Modes.ASSIGN_SINGLE;
    }

    return this.$mdDialog.show({
      resolve: {
        school: () => this.School.get({ id: schoolId }).$promise,
        student: () => (mode === Modes.ASSIGN_MANY ? '' : this.Student.get({ id: studentIds }).$promise),
        studentSupport: () => {
          // edit mode:
          if (studentSupportId) {
            return this.StudentSupport.get({ id: studentSupportId }).$promise;
            // new studentSupport:
          } else {
            const studentSupport = new this.StudentSupport(angular.copy(STUDENT_SUPPORT_TEMPLATE));
            if (mode !== Modes.ASSIGN_MANY) {
              studentSupport._id = this.UtilitiesService.createV4Uuid();
              return studentSupport;
            } else {
              return studentSupport;
            }
          }
        },
        supports: () => this.Support.query({ schoolId }).$promise,
        v3View: () => v3View,
      },
      locals: {
        mode,
        studentIds,
        exam,
      },
      disableParentScroll: true,
      template: mode.template,
      parent: angular.element(document.body),
      clickOutsideToClose: false,
      controller: StudentSupportModalCtrl,
      controllerAs: 'ctrl',
    });
  }
}
